<template>
  <div class="page-card">
    <div class="page-head">
      <h3>Nutrition Records</h3>
    </div>

    <el-form :inline="true" :model="query" size="small" class="search-form">
      <el-form-item label="Keyword">
        <el-input v-model="query.keyword" clearable placeholder="User ID / name / email" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item label="Load">
        <el-select v-model="query.loadLevel" clearable placeholder="All">
          <el-option label="High" value="High" />
          <el-option label="Moderate" value="Moderate" />
          <el-option label="Low" value="Low" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">Search</el-button>
        <el-button @click="resetSearch">Reset</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="list" v-loading="loading" border size="small">
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column label="Athlete" min-width="160" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.athleteName || scope.row.nickname || scope.row.username || '-' }}</template>
      </el-table-column>
      <el-table-column prop="email" label="Email" min-width="180" show-overflow-tooltip />
      <el-table-column prop="recordDate" label="Date" min-width="140" />
      <el-table-column prop="loadLevel" label="Load" width="110" />
      <el-table-column prop="trimpValue" label="TRIMP" width="100" />
      <el-table-column label="Targets g/kg" min-width="210">
        <template slot-scope="scope">
          C {{ scope.row.carbTargetGKg }} / P {{ scope.row.proteinTargetGKg }} / F {{ scope.row.fatTargetGKg }}
        </template>
      </el-table-column>
      <el-table-column label="Hydration" min-width="150">
        <template slot-scope="scope">{{ scope.row.hydrationMl || 0 }} / {{ scope.row.hydrationTargetMl || 2500 }} ml</template>
      </el-table-column>
      <el-table-column label="Confirmed" width="110">
        <template slot-scope="scope">
          <el-tag :type="scope.row.confirmed ? 'success' : 'warning'" size="small">{{ scope.row.confirmed ? 'Yes' : 'No' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="Updated At" min-width="160" />
      <el-table-column label="Actions" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" class="danger" @click="remove(scope.row)">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pager"
      background
      layout="total, sizes, prev, pager, next"
      :total="total"
      :page-size="query.pageSize"
      :current-page="query.pageNum"
      :page-sizes="[10, 20, 50, 100]"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { nutritionApi } from '@/api/health'

const emptyQuery = () => ({ pageNum: 1, pageSize: 10, keyword: '', loadLevel: '' })

export default {
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: emptyQuery()
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await nutritionApi.list(this.query)
        const data = res.data || {}
        this.list = data.records || []
        this.total = Number(data.total || 0)
      } finally {
        this.loading = false
      }
    },
    search() {
      this.query.pageNum = 1
      this.loadData()
    },
    resetSearch() {
      this.query = emptyQuery()
      this.loadData()
    },
    handleSizeChange(size) {
      this.query.pageSize = size
      this.query.pageNum = 1
      this.loadData()
    },
    handleCurrentChange(page) {
      this.query.pageNum = page
      this.loadData()
    },
    async remove(row) {
      await this.$confirm(`Delete nutrition record #${row.id}?`, 'Confirm', { type: 'warning' })
      await nutritionApi.remove(row.id)
      this.$message.success('Deleted successfully')
      this.loadData()
    }
  }
}
</script>

<style scoped>
.page-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
.page-head h3 { margin: 0; }
.search-form { margin-bottom: 12px; }
.pager { margin-top: 16px; text-align: right; }
.danger { color: #f56c6c; }
</style>
